<div class="modal--generic confirm-legal-guardian__modal">
  <h1 class="modal__header">The owner is the insured's legal guardian.</h1>
  <p class="modal__text">
    We wil indicate that the insured is the owner's ward. By clicking "Confirm", you consent to this change.
  </p>

  <div class="modal__actions modal__actions--inline">
    <button cpdsButton theme="mm-light" variant="secondary" (click)="confirm()">Confirm</button>
    <button cpdsButton theme="mm-light" variant="tertiary" (click)="cancel()">Go Back</button>
  </div>
</div>
